define(['underscore'], function(_) {
    var Extensions = {
        // Nested Models
        NestedModels: function(backbone) {
            backbone.NestedModel = backbone.Model.extend({
                constructor: function(attrs, options) {
                    _.each(
                        this.relations,
                        function(RelatedClass, key) {
                            if (
                                !(
                                    RelatedClass.prototype instanceof backbone.NestedModel ||
                                    RelatedClass.prototype instanceof backbone.Collection
                                )
                            ) {
                                console.error(
                                    'Related class for ',
                                    key,
                                    ' must be extended from backbone.NestedModel or backbone.Collection'
                                );
                                return;
                            }
                            if (!_.isUndefined(attrs[key]) || _.has(this.defaults, key)) {
                                return;
                            }

                            attrs[key] = RelatedClass instanceof backbone.Collection ? [] : {};
                        },
                        this
                    );

                    backbone.Model.prototype.constructor.call(this, attrs, options);
                },

                set: function() {
                    this._set.apply(this, arguments);
                },

                _set: function() {
                    if (arguments[0] == null) return {};

                    var _this = this;
                    var key; // String
                    var value; // Any
                    var attrs; // Object
                    var options; // Object

                    var changed; // Array | Boolean(false)
                    var changes = {};

                    if (_.isObject(arguments[0])) {
                        attrs = arguments[0];
                        options = arguments[1];

                        for (var key in attrs) {
                            if (!_.has(attrs, key)) continue;
                            changed = this._setSingleValue(key, attrs[key], options);
                            changed && (changes[key] = changed.changes);
                        }
                    } else {
                        key = arguments[0];
                        value = arguments[1];
                        options = arguments[2];

                        changed = this._setSingleValue(key, value, options);
                        changed && (changes = changed.changes);
                    }

                    _.size(changes) && this.trigger('change', changes, options);

                    // todo: add NestedCollection and put it in there to make available events catching for simple backbone Models
                    if (this.collection) {
                        var changedCollection = [];
                        var index = this.collection.indexOf(this);

                        if (~index) {
                            changedCollection[this.id || this.cid] = changes;
                            _.size(changes) && this.collection.trigger('change', this.collection, this, options, changedCollection);
                        }
                    }

                    return changes;
                },

                _setSingleValue: function(key, value, options) {
                    var RelatedClass = this.relations && typeof this.relations[key] === 'function' && this.relations[key];

                    var localChanges; // Array
                    var changes = {}; // Array
                    var child; // RelatedClass

                    // mute standart "change" events
                    options = _.extend(options || {}, { silent: true });

                    if (RelatedClass && value !== null) {
                        switch (true) {
                            case value instanceof RelatedClass:
                                backbone.Model.prototype.set.call(this, key, value, options);
                                changes = value.toJSON();
                                break;

                            case !_.isObject(value):
                            case value instanceof backbone.Model:
                            case value instanceof backbone.Collection:
                                console.error('Value should be the instance of related class, plain object or null', typeof value);
                                return false;

                            case this.get(key) instanceof RelatedClass:
                                switch (true) {
                                    case this.get(key) instanceof backbone.Collection:
                                        this.get(key).set(value, options);
                                        changes = this.get(key).toJSON();
                                        break;

                                    case this.get(key) instanceof backbone.NestedModel:
                                        changes = this.get(key)._set(value, options);
                                        if (_.size(changes) === 0) {
                                            return false;
                                        }
                                        break;
                                }
                                break;

                            default:
                                child = this._linkChild(key, new RelatedClass(value));
                                backbone.Model.prototype.set.call(this, key, child, options);
                                changes = child.toJSON();
                        }
                    } else {
                        if (_.isEqual(this.attributes[key], value)) {
                            return false;
                        }
                        backbone.Model.prototype.set.call(this, key, value, options);
                        changes = value;
                    }

                    this.trigger('change:' + key, this, changes, options);

                    return {
                        changes: changes
                    };
                },

                _linkChild: function(key, child) {
                    child.__host = this;
                    child.__host_key = key;
                    child.on('change add remove', this._informParent, child);

                    return child;
                },

                _informParent: function(eventNames, model, options, changes) {
                    var hash = {};

                    switch (true) {
                        case this instanceof backbone.NestedModel: // (model, options, changes)
                            changes = arguments[2];
                            break;

                        case this instanceof backbone.Model: // (model, options)
                        case this instanceof backbone.Collection: // (collection, model, options, [changes])
                            if (_.isUndefined(changes)) {
                                changes = this.toJSON();
                            }
                            break;
                    }

                    hash[this.__host_key] = changes;

                    this.__host.trigger('change', this, options, hash);
                    this.__host.trigger('change:' + this.__host_key, this, hash, options);
                },

                toJSON: function() {
                    return toJSON(this.attributes);
                }
            });

            backbone.NestedModel.extend = function() {
                var child = backbone.Model.extend.apply(this, arguments);

                child.prototype.relations = _.extend({}, this.prototype.relations, child.prototype.relations);
                child.prototype.defaults = _.extend({}, this.prototype.defaults, child.prototype.defaults);

                return child;
            };

            // Helpers

            function toJSON(source) {
                var dest = _.isArray(source) ? [] : {};

                _.each(source, function(value, key) {
                    switch (true) {
                        case value instanceof backbone.Model:
                        case value instanceof backbone.Collection:
                            dest[key] = value.toJSON();
                            break;

                        case _.isObject(value):
                            dest[key] = toJSON(value);
                            break;

                        default:
                            dest[key] = value;
                    }
                });

                return dest;
            }
        }
    };

    return {
        inject: function(backbone) {
            _.each(Extensions, function(extension) {
                if (typeof extension === 'function') {
                    extension(backbone);
                }
            });
        }
    };
});
